var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M11 0C4.934 0 0 4.934 0 11s4.934 11 11 11 11-4.934 11-11S17.066 0 11 0z",
    transform: "translate(-728 -1088) translate(728 852) translate(0 236)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M15.813 11.917h-3.896v3.896c0 .506-.41.916-.917.916-.506 0-.917-.41-.917-.916v-3.896H6.187c-.506 0-.916-.41-.916-.917 0-.506.41-.917.917-.917h3.895V6.187c0-.506.41-.916.917-.916.506 0 .917.41.917.917v3.895h3.896c.506 0 .916.41.916.917 0 .506-.41.917-.916.917z",
    transform: "translate(-728 -1088) translate(728 852) translate(0 236)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.de04f8467d0c719ce58fb00cf127cf86.svg";
export { ForwardRef as ReactComponent };